/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.name = exports.Share = void 0;

var react_1 = __importDefault(require("react"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var FACEBOOK = 'facebook';
var INSTAGRAM = 'instagram';
var LINKEDIN = 'linkedin';
var TWITTER = 'twitter';
var name = 'Share';
exports.name = name;

var Share = function Share(_ref) {
  var Frame = _ref.Frame,
      Link = _ref.Link,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.buildUrl = _this.buildUrl.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "buildUrl",
      value: function buildUrl() {
        var configCode = this.props.configCode;
        return "".concat(window.location.origin, "/build/").concat(configCode);
      }
    }, {
      key: "getShareLink",
      value: function getShareLink(platform, url) {
        switch (platform) {
          case FACEBOOK:
            return "https://www.facebook.com/sharer.php?u=".concat(encodeURI(url));

          case TWITTER:
            return "https://twitter.com/intent/tweet?url=".concat(encodeURI(url));

          case LINKEDIN:
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(url));
        }
      }
    }, {
      key: "renderSharePDF",
      value: function renderSharePDF(opts, classes) {
        var _a, _b;

        var share = [];

        if ((_a = opts === null || opts === void 0 ? void 0 : opts.pdf) === null || _a === void 0 ? void 0 : _a.print) {
          share.push(react_1.default.createElement(Link, {
            key: "print"
          }, "Print PDF"));
        }

        if ((_b = opts === null || opts === void 0 ? void 0 : opts.pdf) === null || _b === void 0 ? void 0 : _b.download) {
          share.push(react_1.default.createElement(Link, {
            key: "download"
          }, "Download PDF"));
        }

        if (share.length === 2) {
          share.splice(1, 0, react_1.default.createElement(Text, {
            className: ['Share__divider', classes === null || classes === void 0 ? void 0 : classes.divider],
            style: styles === null || styles === void 0 ? void 0 : styles.divider
          }, "|"));
        }

        return share;
      }
    }, {
      key: "renderSocialMedia",
      value: function renderSocialMedia(props) {
        var Facebook = props.Facebook,
            Instagram = props.Instagram,
            LinkedIn = props.LinkedIn,
            opts = props.opts,
            Twitter = props.Twitter;
        var html = [];
        var url = this.buildUrl();

        if (Facebook || (opts === null || opts === void 0 ? void 0 : opts.Facebook)) {
          html.push(react_1.default.createElement(Link, {
            target: "_blank",
            href: this.getShareLink(FACEBOOK, url)
          }, Facebook));
        }

        if (LinkedIn || (opts === null || opts === void 0 ? void 0 : opts.LinkedIn)) {
          html.push(react_1.default.createElement(Link, {
            target: "_blank",
            href: this.getShareLink(LINKEDIN, url)
          }, LinkedIn));
        }

        if (Twitter || (opts === null || opts === void 0 ? void 0 : opts.Twitter)) {
          html.push(react_1.default.createElement(Link, {
            target: "_blank",
            href: this.getShareLink(TWITTER, url)
          }, Twitter));
        }

        return html;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            opts = _this$props.opts;
        return react_1.default.createElement(Frame, {
          className: ['Share__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, this.renderSharePDF(opts, classes), this.renderSocialMedia(this.props), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Share = Share;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app;
  var env = app.env;
  var configCode = api.configCode;
  return {
    configCode: configCode,
    env: env
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a;

  return {
    container: Object.assign({
      display: 'flex',
      justifyContent: 'center',
      padding: 20
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Share) === null || _a === void 0 ? void 0 : _a.container),
    divider: Object.assign({}, StyleUtils_1.default.margin('0 10px'))
  };
};

exports.style = style;